import { render, staticRenderFns } from "./PatientMessageModal.vue?vue&type=template&id=948a1b60"
import script from "./PatientMessageModal.vue?vue&type=script&lang=js"
export * from "./PatientMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports